import { render, staticRenderFns } from "./ResponsiveCardList.vue?vue&type=template&id=134542e0&scoped=true&"
import script from "./ResponsiveCardList.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveCardList.vue?vue&type=script&lang=ts&"
import style0 from "./ResponsiveCardList.vue?vue&type=style&index=0&id=134542e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134542e0",
  null
  
)

export default component.exports